var React = require('react');

function IconPhone (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1419.878 -63.898)"},[React.createElement("path",{"d":"M4,1A3,3,0,0,0,1,4V22a3,3,0,0,0,3,3h9a3,3,0,0,0,3-3V4a3,3,0,0,0-3-3H4M4,0h9a4,4,0,0,1,4,4V22a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z","transform":"translate(1419.878 63.898)","fill":"#dab26f","key":0}),React.createElement("path",{"d":"M8,.5H0v-1H8Z","transform":"translate(1424.378 84.296)","fill":"#dab26f","key":1})]));
}

IconPhone.defaultProps = {"width":"17","height":"26","viewBox":"0 0 17 26"};

module.exports = IconPhone;

IconPhone.default = IconPhone;
